<template>
  <div style="padding: 20px">
    <el-button
      type="primary"
      @click="editUser('add')"
      style="marginBottom: 10px"
      >添加风机类型概算</el-button
    >
    <pagination-table
      ref="table"
      :data="turbineList"
      :columns="columns"
      :actions="actions"
      :loader="getInvestTurbineList"
      :async="true"
      :height="tableHeight"
      :pageSizes="[20]"
    ></pagination-table>
    <el-dialog
      v-drag:common
      :visible="visible"
      title="新增风机类型概算"
      width="1100px"
      @close="cancel"
      class="transtant-input"
    >
      <div style="height: 400px;overflow: auto;">
        <el-form
          :inline="true"
          label-position="right"
          label-width="200px"
          :rules="rules"
          :model="formData"
          ref="ruleForm"
        >
          <el-form-item label="风机类型名称" prop="turbineTypeName">
            <el-input
              v-model="formData.turbineTypeName"
              placeholder="请输入风机类型名称"
              style="width: 300px"
              :maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item label="轮毂高度（m）" prop="hubHeight">
            <el-input
              v-model="formData.hubHeight"
              placeholder="请输入轮毂高度"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="额定功率（万kW）" prop="ratedPower">
            <el-input
              v-model="formData.ratedPower"
              placeholder="请输入额定功率"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="台数" prop="count">
            <el-input
              v-model="formData.count"
              placeholder="请输入台数"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="容量（万kW）" prop="cap">
            <el-input
              v-model="formData.cap"
              placeholder="请输入容量"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="主机单价（元/kW）" prop="hostCost">
            <el-input
              v-model="formData.hostCost"
              placeholder="请输入主机单价"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="基础价格（万元/座）" prop="baseCost">
            <el-input
              v-model="formData.baseCost"
              placeholder="请输入基础价格"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="基础折算单价（元/kW）" prop="baseConversionCost">
            <el-input
              v-model="formData.baseConversionCost"
              placeholder="请输入基础折算单价"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="吊装费用（万元/台）" prop="hoistingCost">
            <el-input
              v-model="formData.hoistingCost"
              placeholder="请输入吊装费用"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="吊装折算单价（元/kW）"
            prop="hoistingConversionCost"
          >
            <el-input
              v-model="formData.hoistingConversionCost"
              placeholder="请输入吊装折算单价"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="塔筒价格（万元/t）" prop="tubeCost">
            <el-input
              v-model="formData.tubeCost"
              placeholder="请输入塔筒价格"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="塔筒重量（t）" prop="tubeWeight">
            <el-input
              v-model="formData.tubeWeight"
              placeholder="请输入塔筒重量"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="塔筒总价（万元）" prop="tubeTotalCost">
            <el-input
              v-model="formData.tubeTotalCost"
              placeholder="请输入塔筒总价"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="塔筒折算单价（元/kW）" prop="tubeConversionCost">
            <el-input
              v-model="formData.tubeConversionCost"
              placeholder="请输入塔筒折算单价"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="箱变（万元/个）" prop="boxTransformer">
            <el-input
              v-model="formData.boxTransformer"
              placeholder="请输入箱变"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="箱变折算单价（元/kW）" prop="boxConversionCost">
            <el-input
              v-model="formData.boxConversionCost"
              placeholder="请输入箱变折算单价"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="征地费用指标（万元/台）"
            prop="landAcquisitionTarget"
          >
            <el-input
              v-model="formData.landAcquisitionTarget"
              placeholder="请输入征地费用指标"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="征地折算单价（元/kW）"
            prop="landAcquisitionConversionCost"
          >
            <el-input
              v-model="formData.landAcquisitionConversionCost"
              placeholder="请输入征地折算单价"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="发电小时（h）" prop="hours">
            <el-input
              v-model="formData.hours"
              placeholder="请输入发电小时"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="上述主要差别项单价（元/kW）"
            prop="differenceCost"
          >
            <el-input
              v-model="formData.differenceCost"
              placeholder="请输入上述主要差别项单价"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="其他费用单价（元/kW）" prop="otherCost">
            <el-input
              v-model="formData.otherCost"
              placeholder="请输入其他费用单价"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="单位静态投资（元/kW）"
            prop="unitStaticInvestment"
          >
            <el-input
              v-model="formData.unitStaticInvestment"
              placeholder="请输入单位静态投资"
              style="width: 300px"
              :maxlength="10"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn">
        <el-button type="primary" @click="saveOwner">保存</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { number } from '@/utils/rules';

export default {
  data() {
    return {
      turbineList: [],
      visible: false,
      type: '',
      formData: {
        baseConversionCost: '',
        baseCost: '',
        boxConversionCost: '',
        boxTransformer: '',
        cap: '',
        count: '',
        dataId: undefined,
        differenceCost: '',
        hoistingConversionCost: '',
        hoistingCost: '',
        hostCost: '',
        hours: '',
        hubHeight: '',
        landAcquisitionConversionCost: '',
        landAcquisitionTarget: '',
        otherCost: '',
        ratedPower: '',
        tubeConversionCost: '',
        tubeCost: '',
        tubeTotalCost: '',
        tubeWeight: '',
        turbineTypeName: '',
        unitStaticInvestment: ''
      },
      rules: {
        turbineTypeName: [
          { required: true, message: '请输入风机类型名称', trigger: 'blur' }
        ],
        hubHeight: [number({ required: true })],
        ratedPower: [number({ required: true })],
        count: [number({ required: true })],
        cap: [number({ required: true })],
        hostCost: [number({ required: true })],
        baseCost: [number({ required: true })],
        baseConversionCost: [number({ required: true })],
        hoistingCost: [number({ required: true })],
        hoistingConversionCost: [number({ required: true })],
        tubeCost: [number({ required: true })],
        tubeWeight: [number({ required: true })],
        tubeTotalCost: [number({ required: true })],
        tubeConversionCost: [number({ required: true })],
        boxTransformer: [number({ required: true })],
        boxConversionCost: [number({ required: true })],
        landAcquisitionTarget: [number({ required: true })],
        landAcquisitionConversionCost: [number({ required: true })],
        hours: [number({ required: true })],
        differenceCost: [number({ required: true })],
        otherCost: [number({ required: true })],
        unitStaticInvestment: [number({ required: true })]
      },
      columns: [
        {
          prop: 'turbineTypeName',
          label: '风机类型名称',
          fixed: true,
          width: '120px'
        },
        {
          prop: 'hubHeight',
          label: '轮毂高度',
          unit: '（m）'
        },
        {
          prop: 'ratedPower',
          label: '额定功率',
          unit: '（万kW）'
        },
        {
          prop: 'count',
          label: '台数',
          width: '50px'
        },
        {
          prop: 'cap',
          label: '容量 ',
          unit: '（万kW）',
          width: '110px'
        },
        {
          prop: 'hostCost',
          label: '主机单价',
          unit: '（元/kW）',
          width: '100px'
        },
        {
          prop: 'baseCost',
          label: '基础价格',
          unit: '（万元/座）',
          width: '100px'
        },
        {
          prop: 'baseConversionCost',
          label: '基础折算单价',
          unit: '（元/kW）',
          width: '110px'
        },
        {
          prop: 'hoistingCost',
          label: '吊装费用',
          unit: '（万元/台）',
          width: '90px'
        },
        {
          prop: 'hoistingConversionCost',
          label: '吊装折算单价',
          unit: '（元/kW）',
          width: '110px'
        },
        {
          prop: 'tubeCost',
          label: '塔筒价格',
          unit: '（万元/t）'
        },
        {
          prop: 'tubeWeight',
          label: '塔筒重量',
          unit: '（t）'
        },
        {
          prop: 'tubeTotalCost',
          label: '塔筒总价',
          unit: '（万元）'
        },
        {
          prop: 'tubeConversionCost',
          label: '塔筒折算单价',
          unit: '（元/kW）',
          width: '110px'
        },
        {
          prop: 'boxTransformer',
          label: '箱变',
          unit: '（元/kW）',
          width: '100px'
        },
        {
          prop: 'boxConversionCost',
          label: '箱变折算单价',
          unit: '（元/kW）',
          width: '110px'
        },
        {
          prop: 'landAcquisitionTarget',
          label: '征地费用指标',
          unit: '（万元/台）',
          width: '100px'
        },
        {
          prop: 'landAcquisitionConversionCost',
          label: '征地折算单价',
          unit: '（元/kW）',
          width: '110px'
        },
        {
          prop: 'hours',
          label: '发电小时',
          unit: '（h）'
        },
        {
          prop: 'differenceCost',
          label: '上述主要差别项单价',
          unit: '（元/kW）',
          width: '130px'
        },
        {
          prop: 'otherCost',
          label: '其他费用单价',
          unit: '（元/kW）',
          width: '110px'
        },
        {
          prop: 'unitStaticInvestment',
          label: '单位静态投资',
          unit: '（元/kW）',
          width: '100px'
        }
      ],
      actions: [
        {
          label: '编辑',
          type: 'primary',
          plain: true,
          style: 'btn',
          width: '60px',
          onClick: (index, row) => {
            this.editUser('edit', row);
          }
        },
        {
          label: '删除',
          type: 'danger',
          plain: true,
          style: 'btn',
          width: '60px',
          onClick: (index, row) => {
            this.delUser(row);
            //console.log(row, 'row....');
          }
        }
      ]
    };
  },
  async mounted() {
    await this.getInvestTurbineList({ page: 0 });
  },
  computed: {
    tableHeight() {
      return window.innerHeight - 220;
    }
  },
  methods: {
    cancel() {
      // this.$refs.ruleForm.resetFields();
      this.formData = {
        baseConversionCost: '',
        baseCost: '',
        boxConversionCost: '',
        boxTransformer: '',
        cap: '',
        count: '',
        dataId: undefined,
        differenceCost: '',
        hoistingConversionCost: '',
        hoistingCost: '',
        hostCost: '',
        hours: '',
        hubHeight: '',
        landAcquisitionConversionCost: '',
        landAcquisitionTarget: '',
        otherCost: '',
        ratedPower: '',
        tubeConversionCost: '',
        tubeCost: '',
        tubeTotalCost: '',
        tubeWeight: '',
        turbineTypeName: '',
        unitStaticInvestment: ''
      };
      this.visible = false;
    },
    async getInvestTurbineList(options) {
      const { data } = await this.$fetch(
        '/manage/economic/getInvestTurbineList',
        {
          module: 'manage',
          params: { pageNo: options.page }
        }
      );
      this.turbineList = data.data && data.data.rows;
      return {
        data: data.data && data.data.rows,
        total: data.data && data.data.total
      };
    },
    async delUser(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(async () => {
          await this.$postForm({
            url: '/manage/economic/deleteInvestTurbineInfo',
            module: 'manage',
            data: { dataId: row.dataId },
            showLoading: true,
            showError: true,
            showSuccess: true
          });
          this.$refs.table.load();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    async editUser(type, row) {
      this.visible = true;
      this.type = type;
      if (type === 'edit') {
        this.formData = row;
      }
    },
    async saveOwner() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          if (this.type === 'edit') {
            await this.$fetch({
              url: '/manage/economic/updateInvestTurbineInfo',
              module: 'manage',
              method: 'post',
              data: {
                investTurbineInfo: this.formData
              },
              showLoading: true,
              showError: true,
              showSuccess: true
            });
          } else {
            await this.$fetch({
              url: '/manage/economic/saveInvestTurbineInfo',
              module: 'manage',
              method: 'post',
              data: {
                investTurbineInfo: { ...this.formData, dataId: 0 }
              },
              showLoading: true,
              showError: true,
              showSuccess: true
            });
          }
          this.$refs.ruleForm.resetFields();
          this.$refs.table.load();
          this.visible = false;
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-table__empty-block {
  background-color: #fff;
}
/deep/.el-form {
  padding: 10px;
  .el-form-item__label {
    color: #ffffff;
  }
}
/deep/.btn {
  display: flex;
  justify-content: center;
  align-items: center;

  .el-button {
    display: inline-block;
  }
}
</style>
